/* lua.js generated code 0.3.0 */

SpriteLabel = xClass("SpriteLabel", cc.Layer)

// config = {
// 	plist = "cocos/properties.plist",
// 	png = "cocos/properties.png",
// 	spriteName = "properties/num{id}.png",
// 	charSet = {"0","1","2","3","4","5","6","7","8","9","+"},
// 	charWidth = 0, 这个值不为零就是等宽字体
// 	charSetAlign = cc.VERTICAL_TEXT_ALIGNMENT_CENTER,
// 	charMargin = 1,
// }

SpriteLabel.prototype.ctor = function (config, str, color) {
    var self = this
    cc.Layer.prototype.ctor.call(self)
    config = clone(config || table())
    config.plist = config.plist || "cocos/properties.plist"
    config.png = config.png || "cocos/properties.png"
    config.spriteName = config.spriteName || "properties/num{id}.png"
    config.charSet = config.charSet || table(
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "+"
    )
    config.charWidth = config.charWidth || 0
    config.charSetAlign = config.charSetAlign || cc.VERTICAL_TEXT_ALIGNMENT_CENTER
    config.charMargin = config.charMargin || 1
    color = color || cc.c4b(255, 255, 255, 255)
    self.setCascadeOpacityEnabled(true)
    self.init(config, null, null, null, color)
    self.setString(str)
}
SpriteLabel.prototype.init = function (config, size, hAlign, vAlign, color) {
    var self = this
    self.config = config
    self.charSet = self.formatCharSet()
    self.ignoreAnchorPointForPosition(false)
    FrameLoader.loadImageWithPlist(self.config.plist)
    self.strValue = ""
    self.formattedString = ""
    self.textColor = clone(color) || cc.c4b(255, 255, 255, 255)
}
SpriteLabel.prototype.getString = function () {
    var self = this
    return self.strValue
}
SpriteLabel.prototype.setString = function (str) {
    var self = this
    self.strValue = tostring(str || "")

    var formattedStr 
    if (self.strValue == "")
        formattedStr = ""
    else
        formattedStr = self.formatString(self.strValue)

    if (formattedStr === self.formattedString) {
        return
    }
    self.formattedString = formattedStr
    self.refresh()
}
// cc.c4b
SpriteLabel.prototype.setTextColor = function (color) {
    var self = this
    if (self.textColor.r === color.r && self.textColor.g === color.g && self.textColor.b === color.b && self.textColor.a === color.a) {
        return
    }
    self.textColor = clone(color)
    self.refresh()
}
// 这个接口是用来做HACK的 用于实现一些特殊的需求 或者是做效率优化
SpriteLabel.prototype.getSprites = function () {
    return sTable([2, this.getChildren()])
}
SpriteLabel.prototype.formatCharSet = function () {
    var self = this
    var ret = table()
    for (var i = 1, v = self.config.charSet[1]; v; i++ , v = self.config.charSet[i]) {
        ret[v] = true
    }
    return ret
}
SpriteLabel.prototype.formatString = function (value) {
    var ret = ""
    // var $st14 = string.gfind(value, "[%z\\1-\\127\\194-\\244][\\128-\\191]*")
    // while(1) {
    //     var t = $st14[0]($st14[1], $st14[2])
    //     var uchar = t[0]
    //     if (uchar == null) break
    //     $st14[2] = uchar
    //     // if (self.charSet[string.getUnicode(uchar)]) {
    //     if (self.charSet[uchar]) {
    //         ret = ret + uchar
    //     }
    // }
    for (var i = 0; i < value.length; i++) {
        if (this.charSet[value[i]]) {
            ret += value[i]
        }
    }
    return ret
}
SpriteLabel.prototype.setSpriteName = function (spriteName) {
    var self = this
    if (self && self.config) {
        self.config.spriteName = spriteName
    }
}
SpriteLabel.prototype.refresh = function () {
    var self = this
    self.removeAllChildren(true)
    var [charArray, strSize] = [table(), cc.size(0, 0)]
    for (var i = 0; i < self.formattedString.length; i++) {
        let uchar = self.formattedString[i]
        var spriteName = self.config.spriteName.replace("{id}", uchar.charCodeAt(0))
        var sprite = cc.Sprite.createWithSpriteFrameName(spriteName)
        sprite.setColor(cc.c3b(self.textColor.r, self.textColor.g, self.textColor.b))
        sprite.setOpacity(self.textColor.a)
        table.insert(charArray, sprite)
        var cSize = sprite.getContentSize()
        strSize.width = strSize.width + cSize.width + self.config.charMargin
        strSize.height = Math.max(strSize.height, cSize.height)
    }
    strSize.width = Math.max(strSize.width - self.config.charMargin, 0)
    var width = 0
    for (var i = 1, v = charArray[1]; v; i++ , v = charArray[i]) {
        var cSize = v.getContentSize()
        var y = strSize.height / 2
        if (self.config.charSetAlign === cc.VERTICAL_TEXT_ALIGNMENT_TOP) {
            y = strSize.height - cSize.height / 2
        } else if (self.config.charSetAlign === cc.VERTICAL_TEXT_ALIGNMENT_BOTTOM) {
            y = cSize.height / 2
        }
        self.addChild(v)
        if (self.config.charWidth === 0) {
            v.setPosition(cc.p(width + cSize.width / 2, y))
            width = width + cSize.width + self.config.charMargin
        } else {
            v.setPosition(cc.p(width + self.config.charWidth / 2, y))
            width = width + self.config.charWidth + self.config.charMargin
        }
    }
    width = width - self.config.charMargin
    self.setContentSize(cc.size(width, strSize.height))
}
